import React from 'react';

import Raven from 'raven-js';

import {
  Card as CardIcon,
  PaymentApplePay as PaymentApplePayIcon,
  PaymentBancontact as PaymentBancontactIcon,
  PaymentGoogleMicrosoft as PaymentGoogleMicrosoftIcon,
  PaymentIdeal as PaymentIdealIcon,
  PaymentPaypal as PaymentPaypalIcon,
} from '../../../components/icons';
import { Track } from '../../../weborder/analytics';
import * as Api from '../../../weborder/Api';
import * as Data from '../../../weborder/Data';
import { paymentApiServices } from '../../../weborder/services';
import { Utilities } from '../../../weborder/Utilities';
import { TranslateFunction } from 'react-localize-redux';

type PaymentTypeDetails = {
  fdKey: string;
  icon: JSX.Element;
  text: string;
};

export function getPaymentTypeDetails(
  payment: WebOrder.State.Payment,
  translate: TranslateFunction,
): PaymentTypeDetails {
  let icon: JSX.Element = <CardIcon />;
  let text: string = payment.Description;
  const fdKey = `payment-delete-${payment.paymentId}`;

  switch (payment.PaymentAccountType) {
    case Api.GatewayPaymentAccount.Bancontact: {
      icon = <PaymentBancontactIcon />;
      text = payment.Description;
      break;
    }

    case 'BrainTreePayPalPaymentAccount': {
      icon = <PaymentPaypalIcon />;
      text = `PayPal (${payment.Description.slice(
        payment.Description.indexOf(' '),
      )})`;
      break;
    }

    case 'CardPaymentAccount': {
      icon = <CardIcon />;
      const cardNumber = payment.Description.slice(
        payment.Description.indexOf('*'),
      );
      text = `${translate('Card')} ${cardNumber || ''}`;
      break;
    }

    case 'StripePayButtonPaymentAccount': {
      text = payment.Description;

      if (payment.Description === 'Apple_pay') {
        icon = <PaymentApplePayIcon />;
      } else {
        icon = <PaymentGoogleMicrosoftIcon />;
      }
      break;
    }

    case Api.GatewayPaymentAccount.Ideal: {
      icon = <PaymentIdealIcon />;
      text = payment.Description;
      break;
    }

    default:
      icon = <CardIcon />;
      text = translate(payment.Description, undefined, {
        missingTranslationMsg: payment.Description,
      }) as string;
      break;
  }

  return {
    text,
    icon,
    fdKey,
  };
}

export const handleAddCard = (): void => {
  Track('Payments', 'Add New Card Begin');
  Utilities.navigateTo(`/card/${encodeURIComponent(window.location.hash)}`);
};

export const handleDelete = (
  appConfig: Data.Async<Api.AppConfig>,
  customer: Data.Async<Api.Customer>,
  paymentAccountId: number,
  translate: TranslateFunction,
): void | string => {
  paymentApiServices
    .remove({ paymentAccountId })
    .then(() => {
      return;
    })
    .catch((error) => {
      const appconfigLog: any = {};
      const customerLog: any = {};

      if (appConfig.status === 'success') {
        appconfigLog.AppNameId = appConfig.data.AppNameId;
        appconfigLog.WhiteLabelId = appConfig.data.WhiteLabelId;
      }

      if (customer.status === 'success') {
        customerLog.CustomerName = customer.data.CustomerName;
        customerLog.EmailAddress = customer.data.EmailAddress;
      }

      Raven.captureMessage('Error deleting payment method', {
        tags: { category: 'API failure' },
        extra: {
          error: Utilities.handleError(error),
          appconfig: appconfigLog,
          customer: customerLog,
          paymentAccountId: paymentAccountId,
        },
      });

      return (
        error?.response?.data?.UserMessage ||
        translate('Error_deleting_payment_method')
      );
    });
};
